import { LayoutGenerator } from "dependencies/emptyLayout/utils/layoutGenerator"
import { Pagination } from "materials/pagination/menus/model"
/**
 * 门户文本默认配置数据
 */
export const home = [
  {
    titleOptions: [
      {
        height: 60,
        elementOptions: [
          {
            innerElement: "cxPagination",
            type: "cxPagination",
            elementInLayoutId: 0,
            options: new Pagination()
          }
        ]
      }
    ]
  }
]

/**
 * 大屏文本默认配置数据
 */
export const bs = [{}]

/**
 * app数据列表默认配置数据
 */
export const appHome = [
  {
    height: 60,
    elementOptions: [
      {
        innerElement: "cxPagination",
        type: "cxPagination",
        elementInLayoutId: 0,
        options: new Pagination()
      }
    ]
  }
]
